module.exports = __webpack_public_path__ + "img/banner-1-m.e91c8820.jpg";